import { OrangeButton, PrimaryButton } from 'components/Button';
import styled from 'styled-components';

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    margin-top: 40px;
    margin-bottom: 2px;
  }
`;
export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    margin-bottom: 50px;
  }
`;
